import { RBEditorial, RBProgram } from 'store/railsBuilder/reducer.types';
import { RecordingItem } from 'store/recordings/reducer.types';

import { VodEditorial } from 'services/data-manager/types';

import { ImageContentType } from 'components/NagraImage/types';

export default function getContentType(
    item: RBProgram | VodEditorial | RecordingItem,
) {
    return (item as RBProgram).editorial
        ? (item as RBProgram).editorial?.contentType
        : (item as RBEditorial | RecordingItem).contentType ??
              ImageContentType.ANY;
}
